export default __webpack_public_path__ + "static/how-payments-work-24f16a9f9afa749b33d6f7c4392a44b8.png";